<template>
  <div class="guide-container tour-container" v-if="tourStatus">
    <b-container>
      <b-row>
        <b-col class="row-2 bd-top bd-right bd-left" id="v-step-0">{{
          $t('dummyInvoice.title')
        }}</b-col>
      </b-row>

      <b-row>
        <b-col class="col-6 row-4 bd-top bd-left bd-right"></b-col>
        <b-col class="col-6 row-4 bd-top bd-right">
          <b-col class="bd-bottom">
            <b-col class="row-2 col-6 bd-right"></b-col>
          </b-col>
          <b-col class="row-1 bd-bottom"></b-col>
          <b-col class="row-1"></b-col>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="col-6 row-3 bd-top bd-left bd-right"></b-col>
        <b-col class="col-6 row-3 bd-top bd-right">
          <b-col class="row-2 bd-bottom"></b-col>
          <b-col>
            <b-col class="row-1 col-6 bd-right"></b-col>
          </b-col>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="col-6 row-3 bd-top bd-left bd-right">
          <b-col class="row-1 bd-bottom">
            <b-col>
              <b-col class="row-1 col-6 bd-right"></b-col>
            </b-col>
          </b-col>
          <b-col class="row-1 bd-bottom">
            <b-col>
              <b-col class="row-1 col-6 bd-right"></b-col>
            </b-col>
          </b-col>
          <b-col class="row-1">
            <b-col>
              <b-col class="row-1 col-6 bd-right"></b-col>
            </b-col>
          </b-col>
        </b-col>
        <b-col class="col-6 row-3 bd-top bd-right">
          <div id="v-step-1" class="row-3">
            <span class="v1-text">{{ paymentTerm }}</span>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="col-2 row-2 bd-top bd-left bd-right"></b-col>
        <b-col class="col-2 row-2 bd-right bd-top"></b-col>
        <b-col class="col-2 row-2 bd-right bd-top"></b-col>
        <b-col class="row-2 bd-right bd-top"></b-col>
        <b-col class="row-2 bd-right bd-top"></b-col>
        <b-col class="row-2 bd-right bd-top"></b-col>
        <b-col class="row-2 bd-right bd-top"></b-col>
      </b-row>

      <b-row>
        <b-col class="col-12 row-2 bd-top bd-left bd-right"></b-col>
      </b-row>

      <b-row>
        <b-col class="col-9 row-8 bd-top bd-left bd-right">
          <div id="v-step-2" class="row-6">
            <span class="v1-text">{{ assigned }}</span>
          </div>
          <div id="v-step-3" class="row-6">
            <span class="v1-text">
              <bank-details :bank-details="bankDetails" />
            </span>
          </div>
        </b-col>
        <b-col class="col-1 row-8 bd-top bd-right"></b-col>
        <b-col class="col-1 row-8 bd-top bd-right"></b-col>
        <b-col class="col-1 row-8 bd-top bd-right"></b-col>
      </b-row>

      <b-row>
        <b-col class="col-12 row-7 bd-top bd-left bd-right bd-bottom">
          <div class="extension bd-left bd-bottom"></div>
          <div class="extension bd-left bd-bottom"></div>
          <div class="extension bd-left bd-bottom"></div>
          <div class="box bd-left bd-top bd-bottom"></div>
        </b-col>
      </b-row>
    </b-container>
    <v-tour
      name="invoice-guide"
      :steps="steps"
      :options="myOptions"
      :callbacks="myCallbacks"
    >
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
            v-for="(step, index) of tour.steps"
            v-if="tour.currentStep === index"
            :key="index"
            :step="step"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
          >
            <div slot="content">
              <span class="new-line" v-html="step.content"></span>
              <br />
              <bank-details
                :bank-details="bankDetails"
                v-if="step.target === '#v-step-3'"
              />
              <button
                class="pointer"
                v-if="step.showIcon"
                @click.prevent="doCopy(step)"
              >
                <b-icon-files />
              </button>
              <span v-if="copied">{{ $t('dummyInvoice.clipboard') }}</span>
            </div>
            <div slot="actions" class="v-actions text-align-center">
              <button
                @click.prevent="
                  copied = false
                  tour.previousStep()
                "
                v-if="!tour.isFirst"
                class="btn btn-light btn-sm"
              >
                {{ tour.labels.buttonPrevious }}
              </button>
              <button
                @click.prevent="
                  copied = false
                  tour.nextStep()
                "
                v-if="!tour.isLast"
                class="btn btn-primary btn-sm"
              >
                {{
                  tour.isFirst
                    ? $t(`dummyInvoice.buttons.accept`)
                    : tour.labels.buttonNext
                }}
              </button>
              <button
                @click.prevent="
                  copied = false
                  tour.stop()
                "
                v-if="tour.isLast"
                class="btn btn-primary btn-sm"
              >
                {{ tour.labels.buttonStop }}
              </button>
            </div>
          </v-step>
        </transition>
      </template>
    </v-tour>
  </div>
</template>

<script>
import BankDetails from '@/components/BankDetails'
export default {
  name: 'invoice-guide',
  data() {
    return {
      myOptions: {
        useKeyboardNavigation: true,
        labels: {
          buttonPrevious: this.$t(`dummyInvoice.buttons.previous`),
          buttonNext: this.$t(`dummyInvoice.buttons.next`),
          buttonStop: this.$t(`dummyInvoice.buttons.stop`)
        }
      },
      myCallbacks: {
        onStop: this.onStop
      },
      message: null,
      step: 0,
      copied: false
    }
  },
  props: ['tourStatus', 'paymentTerm', 'assigned', 'bankDetails'],
  created() {
    this.updateTourStatus()
  },
  updated() {
    this.updateTourStatus()
  },
  watch: {
    tourStatus: function () {
      this.updateTourStatus()
    }
  },
  methods: {
    doCopy(step) {
      const msg = step.message
        .split('\n')
        .filter((a) => {
          return a.trim()
        })
        .join('\n')
      this.$copyText(msg).then(
        function (e) {
          alert('Copied to Clipboard!')
          return msg.trim()
        },
        function (e) {
          alert('Can not copy')
        }
      )
    },
    updateTourStatus() {
      if (this.tourStatus && this.$tours['invoice-guide']) {
        this.$tours['invoice-guide'].start()
      } else if (this.$tours['invoice-guide']) {
        this.$tours['invoice-guide'].stop()
      }
    },
    onStop() {
      this.$emit('tourStatusChanged', false)
    }
  },
  computed: {
    steps() {
      return [
        {
          target: '#v-step-0',
          content: `Please comply with the following instructions carefully as your invoice may be <span class="text-danger">rejected</span> in case of Negligence.`,
          params: {
            placement: 'right'
          }
        },
        {
          target: '#v-step-1',
          content: `Ensure invoice mentions the correct payment term as "${this.paymentTerm}"`,
          params: {
            placement: 'right'
          }
        },
        {
          target: '#v-step-2',
          showIcon: true,
          message: `${this.assigned}`,
          content: `Please ensure invoice mentions the text-\n \n"${this.assigned}"`,
          params: {
            placement: 'right'
          }
        },
        {
          target: '#v-step-3',
          showIcon: true,
          message: `
                    ${
                      this.bankDetails.bank_name
                        ? 'Bank name: ' + this.bankDetails.bank_name
                        : ''
                    }
                    ${
                      this.bankDetails.bank_address
                        ? 'Bank address: ' + this.bankDetails.bank_address
                        : ''
                    }
                    ${
                      this.bankDetails.swift
                        ? 'Swift Code (If Needed): ' + this.bankDetails.swift
                        : ''
                    }
                    ${
                      this.bankDetails.aba_routing
                        ? 'ABA Routing & Transit No: ' +
                          this.bankDetails.aba_routing
                        : ''
                    }
                    ${
                      this.bankDetails.ac_name
                        ? 'Account Name (For Credit To): ' +
                          this.bankDetails.ac_name
                        : ''
                    }
                    ${
                      this.bankDetails.ac_no
                        ? 'Account No: ' + this.bankDetails.ac_no
                        : ''
                    }
                    ${
                      this.bankDetails.bank_sort_code
                        ? 'Bank Sort Code: ' + this.bankDetails.bank_sort_code
                        : ''
                    }
                    ${
                      this.bankDetails.iban
                        ? 'Iban: ' + this.bankDetails.iban
                        : ''
                    }
                    ${
                      this.bankDetails.beneficiary &&
                      this.bankDetails.beneficiary.bank_name
                        ? 'Beneficiary Name (For Credit To): ' +
                          this.bankDetails.beneficiary.bank_name
                        : ''
                    }
                    ${
                      this.bankDetails.beneficiary &&
                      this.bankDetails.beneficiary.bank_address
                        ? 'Beneficiary Bank Address: ' +
                          this.bankDetails.beneficiary.bank_address
                        : ''
                    }
                    ${
                      this.bankDetails.beneficiary &&
                      this.bankDetails.beneficiary.swift
                        ? 'Beneficiary Swift Code: ' +
                          this.bankDetails.beneficiary.swift
                        : ''
                    }
                    ${
                      this.bankDetails.beneficiary &&
                      this.bankDetails.beneficiary.ac_name
                        ? 'Beneficiary Account Name: ' +
                          this.bankDetails.beneficiary.ac_name
                        : ''
                    }
                    ${
                      this.bankDetails.beneficiary &&
                      this.bankDetails.beneficiary.ac_no
                        ? 'Beneficiary Account Number: ' +
                          this.bankDetails.beneficiary.ac_no
                        : ''
                    }`,
          content: `Please remove your bank details and replace with below details.<br/>`,
          params: {
            placement: 'right'
          }
        }
      ]
    }
  },
  components: {
    BankDetails
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/variables';
.guide-container {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.85);

  .container {
    margin: 5em auto;
    max-width: 500px;
    font-size: 1rem;
    font-weight: 800;
    font-family: $lato;
    text-align: center;

    .row {
      background-color: $drip-bg;
    }
  }
  .col {
    padding: 0;
  }
  .row {
    margin-left: 0;
    margin-right: 0;
  }
}
.pointer {
  border: none;
  padding: inherit;
  text-decoration: none;
  background: none;
  color: $white;

  &:hover {
    cursor: pointer;
  }
}
.v1-text {
  font-size: 12px;
  font-family: $lato;
  line-height: 1.25;
  text-align: left;
  border: 2px solid $danger;
  padding: 6px;
  display: inline-block;
  margin: 5px;
}
.extension {
  width: 39px;
  min-height: 16px;
  float: right;
}
.box {
  width: 117.5px;
  min-height: 50px;
  float: right;
  position: absolute;
  top: 50px;
  right: 0;
}
.bd-top {
  border-top: solid 1px $black;
}
.bd-right {
  border-right: solid 1px $black;
}
.bd-bottom {
  border-bottom: solid 1px $black;
}
.bd-left {
  border-left: solid 1px $black;
}

.row-1 {
  min-height: 1rem;
}
.row-2 {
  min-height: 2rem;
}
.row-3 {
  min-height: 3rem;
}
.row-4 {
  min-height: 4rem;
}
.row-6 {
  min-height: 6rem;
}
.row-7 {
  min-height: 7rem;
}
.row-8 {
  min-height: 15rem;
}
</style>
